<template>
  <v-navigation-drawer
    v-model="drawer"
    fixed
    right
    temporary
    width="450"
    class="pa-0"
  >
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Activate Existing Firm</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="drawer = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container class="pa-6">
      <v-stepper v-model="activationStep" vertical elevation="0" class="pa-0">
        <!-- Step 1: Search Firm -->
        <v-stepper-step :complete="activationStep > 1" step="1">
          Locate your firm
        </v-stepper-step>

        <v-stepper-content step="1">
          <p class="text-body-2 grey--text text--darken-1 mb-4">
            Enter the Firm Number as it appears in your official registration
            documents.
          </p>
          <v-form
            ref="searchForm"
            v-model="searchValid"
            @submit.prevent="searchFirm"
          >
            <v-text-field
              v-model="activationForm.MemberNo"
              label="Firm Number"
              placeholder="e.g. EBK/F/001"
              outlined
              dense
              :rules="[(v) => !!v || 'Firm Number is required']"
              required
              prepend-inner-icon="mdi-office-building"
            ></v-text-field>
            <v-btn
              color="primary"
              block
              @click="searchFirm"
              :loading="loadingExisting"
              class="mt-2 text-capitalize"
            >
              Search Firm
              <v-icon right small>mdi-magnify</v-icon>
            </v-btn>
          </v-form>
        </v-stepper-content>

        <!-- Step 2: Confirm & Update Details -->
        <v-stepper-step :complete="activationStep > 2" step="2">
          Confirm & Update Details
        </v-stepper-step>

        <v-stepper-content step="2">
          <p class="text-caption grey--text mb-4">
            Review the details found. You can update any missing or incorrect
            information before proceeding.
          </p>
          <v-form ref="detailsForm" v-model="detailsValid">
            <v-text-field
              v-model="activationForm.FirstName"
              label="Firm Name"
              outlined
              dense
              :rules="[(v) => !!v || 'Firm Name is required']"
            ></v-text-field>

            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="activationForm.IdentificationDocumentNo"
                  label="PIN"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'PIN is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="activationForm.contactsEntity.VATRegNo"
                  label="Reg No"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Reg No is required']"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-text-field
              v-model="activationForm.Email"
              label="Email Address"
              outlined
              dense
              :rules="[(v) => !!v || 'Email is required']"
            ></v-text-field>

            <v-text-field
              v-model="activationForm.PhoneNo"
              label="Phone Number"
              outlined
              dense
              :rules="[(v) => !!v || 'Phone is required']"
            ></v-text-field>
          </v-form>

          <v-alert type="info" text dense class="text-caption mb-4">
            An activation code will be sent to the email address provided above.
          </v-alert>

          <div class="d-flex">
            <v-btn text @click="activationStep = 1" class="text-capitalize"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="initiateActivation"
              :loading="loadingGlobal"
              :disabled="!detailsValid"
              class="text-capitalize"
            >
              Initiate Activation
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-stepper-content>

        <!-- Step 3: Verify OTP & Password -->
        <v-stepper-step step="3"> Verify & Set Password </v-stepper-step>

        <v-stepper-content step="3">
          <v-form
            ref="verifyForm"
            v-model="verifyValid"
            @submit.prevent="verifyActivation"
          >
            <v-text-field
              v-model="activationForm.otp"
              label="OTP Code"
              placeholder="Enter 6-digit code"
              outlined
              dense
              :rules="[(v) => !!v || 'OTP is required']"
              required
              maxlength="6"
              prepend-inner-icon="mdi-lock-outline"
            ></v-text-field>

            <v-text-field
              v-model="activationForm.password"
              label="New Firm Password"
              placeholder="Secure password for firm account"
              outlined
              dense
              type="password"
              :rules="[(v) => !!v || 'Password is required']"
              required
              prepend-inner-icon="mdi-key-outline"
            ></v-text-field>

            <div class="d-flex mt-4">
              <v-btn text @click="activationStep = 2" class="text-capitalize"
                >Back</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="verifyActivation"
                :loading="loadingGlobal"
                class="text-capitalize px-6"
              >
                Verify & Activate
              </v-btn>
            </div>
          </v-form>
        </v-stepper-content>
      </v-stepper>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "FirmActivationDrawer",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchValid: true,
      detailsValid: true,
      verifyValid: true,
      activationForm: {
        MemberNo: "",
        FirstName: "",
        IdentificationDocumentNo: "",
        contactsEntity: {
          VATRegNo: "",
        },
        Email: "",
        PhoneNo: "",
        otp: "",
        password: "",
      },
    };
  },
  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    user() {
      return this.$store.getters["Auth/user"];
    },
    existingFirm() {
      return this.$store.getters["Firms/existingFirm"];
    },
    loadingExisting() {
      return this.$store.getters["Firms/loadingExisting"];
    },
    loadingGlobal() {
      return this.$store.getters.loading;
    },
    activationStep: {
      get() {
        return this.$store.getters["Firms/activationStep"];
      },
      set(val) {
        this.$store.commit("Firms/SET_ACTIVATION_STEP", val);
      },
    },
  },
  watch: {
    drawer(val) {
      if (!val) {
        this.resetActivation();
      }
    },
    existingFirm(val) {
      if (val) {
        this.activationForm = { ...val };
      }
    },
  },
  methods: {
    async searchFirm() {
      if (this.$refs.searchForm.validate()) {
        try {
          await this.$store.dispatch(
            "Firms/findExistingFirm",
            this.activationForm.MemberNo
          );
        } catch (e) {
          // Error handled in store
        }
      }
    },
    async initiateActivation() {
      if (this.$refs.detailsForm.validate()) {
        try {
          await this.$store.dispatch("Firms/initiateActivation", {
            ...this.activationForm,
          });
        } catch (e) {
          // Error handled in store
        }
      }
    },
    async verifyActivation() {
      if (this.$refs.verifyForm.validate()) {
        try {
          await this.$store.dispatch("Firms/verifyActivation", {
            ...this.activationForm,
            profileID: this.user.profile_id,
          });
          this.drawer = false;
        } catch (e) {
          // Error handled in store
        }
      }
    },
    resetActivation() {
      this.activationForm = {
        firmNo: "",
        firmName: "",
        pin: "",
        regNo: "",
        email: "",
        phone: "",
        otp: "",
        password: "",
      };
      this.$store.commit("Firms/SET_EXISTING_FIRM", null);
      this.$store.commit("Firms/SET_ACTIVATION_STEP", 1);
      if (this.$refs.searchForm) this.$refs.searchForm.resetValidation();
      if (this.$refs.detailsForm) this.$refs.detailsForm.resetValidation();
      if (this.$refs.verifyForm) this.$refs.verifyForm.resetValidation();
    },
  },
};
</script>
